import React from 'react'
import { IconButton, Grid, TextField } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'
import { Link } from 'react-router-dom'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const headerActions = ({
  addDisabled,
  deleteClicked,
  deleteDisabled,
  filterTextChanged,
  filterText,
  translate
}) => {
  let addButton = null
  if (addDisabled) {
    addButton = (
      <IconButton color={'primary'} disabled={addDisabled}>
        <AddIcon />
      </IconButton>
    )
  } else {
    addButton = (
      <Link to={'/employee/add'}>
        <IconButton color={'primary'} disabled={addDisabled}>
          <AddIcon />
        </IconButton>
      </Link>
    )
  }
  return (
    <Grid container justify={'flex-end'} alignItems={'center'} spacing={1}>
      <Grid item>
        <TextField
          inputProps={{ placeholder: translate('search') }}
          onChange={filterTextChanged}
          value={filterText}
        />
      </Grid>
      <Grid item>{addButton}</Grid>
      <Grid item>
        <IconButton color={'secondary'} onClick={deleteClicked} disabled={deleteDisabled}>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default withTranslate(headerActions)
